export default __webpack_public_path__ + "static/media/menu.d12a7d85.svg";